




































































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import Widget from "@/shared/components/Widget.vue";
import { FiservDebitCardStatus, FiservDebitCardsDetailLocation } from "@/shared/types";
import FiservDebitCardSetPinForm from "@/employee/components/settings/hsaBank/FiservDebitCardSetPinForm.vue";
import FiservDebitCardActionMenu from "@/employee/components/settings/hsaBank/FiservDebitCardActionMenu.vue";
import FiservDebitCardDeactivateForm from "@/employee/components/settings/hsaBank/FiservDebitCardDeactivateForm.vue";
import FiservDebitCardReplacementForm from "@/employee/components/settings/hsaBank/FiservDebitCardReplacementForm.vue";
import FiservDebitCardConfirmReplacementForm from "@/employee/components/settings/hsaBank/FiservDebitCardConfirmReplacementForm.vue";
import { useFiservDebitCardsStore } from "@/shared/store/fiservDebitCards";
import { Validator, FieldFlagsBag } from "vee-validate";
import FiservDebitCardAddDependentModal from "@/employee/components/settings/hsaBank/FiservDebitCardAddDependentModal.vue";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
    SettingsHeader,
    SettingsNavigation,
    Widget,
    FiservDebitCardSetPinForm,
    FiservDebitCardActionMenu,
    FiservDebitCardDeactivateForm,
    FiservDebitCardReplacementForm,
    FiservDebitCardConfirmReplacementForm,
    FiservDebitCardAddDependentModal
  },
  filters: {
    capitalize: value => {
      return typeof value === "string"
          ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
          : value;
    }
  }
})
export default class FiservDebitCards extends Vue {
  fiservDebitCardStore = useFiservDebitCardsStore();
  notifierStore = useNotifierStore();

  FiservDebitCardStatus = FiservDebitCardStatus;
  FiservDebitCardsDetailLocation = FiservDebitCardsDetailLocation;
  intervalId: number;

  mounted () {
    this.intervalId = window.setInterval(this.fiservDebitCardStore.getFiservDebitCards, 100);
  }

  beforeDestroy () {
    this.clearInterval();
  }

  clearInterval () {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = 0;
    }
  }

  $validator: Validator;
  fields: FieldFlagsBag;

  manageCardClicked (row) {
    this.fiservDebitCardStore.setFiservDebitCardDetailLocation(FiservDebitCardsDetailLocation.ActionMenu);
    this.toggleRowDetails(row);
  }

  private toggleRowDetails (row: any) {
    if (row.detailsShowing) {
      row.toggleDetails();
    } else {
      this.fiservDebitCardStore.fiservDebitCards.forEach(item => {
        this.$set(item, "_showDetails", false);
      });
      this.$nextTick(() => {
        row.toggleDetails();
      });
    }
  }

  dismissPendingDependent (fiservAuthorizedSignerPendingId: number) {
    this.fiservDebitCardStore.dismissFiservDebitCardPendingDependents(fiservAuthorizedSignerPendingId);
  }

  tableFields = [
    {
      key: "firstName",
      label: "Name on Card"
    },
    {
      key: "cardNumberLast4",
      label: "Last Four of Card Number"
    },
    {
      key: "cardStatus",
      label: "Status"
    },
    {
      key: "isPinSet",
      label: "PIN"
    },
    "actions"
  ];

}
